<template>
  <div class="tacticsBox">
    <el-row style="background: #ffffff;" class="shadow">
      <h3 class="tactics">预测能力分析</h3>
      <el-col :span="24">
        <div style="min-width:1400px;margin-left:69px;">
          <!-- <div class='sub-item-title'>
            <h3>IC值</h3>
          </div> -->
          <vue-echarts
          ref='ICValue'
          width='auto'
          height='340px'
          :renderOnMounted='false'
          :options='{}'
        >
        </vue-echarts>
        </div>
      </el-col>
    </el-row>

    <el-row style="background: #ffffff;margin-top:20px;" class="shadow">
      <h3 class="tactics">行业IR值</h3>
      <el-col :span="24">
        <div style="min-width:1400px;height:430px;margin-left:69px;">
          <vue-echarts
          ref='industryICValue'
          width='auto'
          height='360px'
          :renderOnMounted='false'
          :options='{}'
        >
        </vue-echarts>
        </div>
      </el-col>
    </el-row>
     <el-row style="background: #ffffff;margin-top:20px;" class="shadow">
      <h3 class="tactics">IC衰退情况</h3>
      <el-col :span="24">
        <div style="min-width:1400px;height:430px;margin-left:69px;">
         <vue-echarts
          ref='ICDecline'
          width='auto'
          height='340px'
          :renderOnMounted='false'
          :options='{}'
        >
        </vue-echarts>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// common/kecharts
import tracharts from "./common/tracharts";
import sameEcharts from "./common/sameEcharts";
import echartsTime from "./common/echartsTime";

import vueEcharts from './common/vueEcharts'
 const commonOptions = {
    // title: '',
    backgroundColor: '#fff',
    color: ['#F15A5A', '#9FCFFF', '#FFD96C'],
    // legend: {
    //   data: [],
    //   textStyle: {
    //     color: '#999'
    //   }
    // },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      splitLine: {
        lineStyle: {
          color: '#eee'
        }
      },
      data: []
    },
    yAxis: {
      type: 'value',
      // scale: true,
      splitLine: {
        lineStyle: {
          color: '#eee'
        }
      }
    },
    series: []
  };
// import kecharts from "../../strategy/common/kecharts";
export default {
  components: { tracharts,sameEcharts,echartsTime,vueEcharts },
  props: {
    getData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
data:{},


      distribute: {
        dataValue: [],
        tiem: []
      },
      // 因子行业
      industry: {
        dataValue: [],
        tiem: []
      },
      sCombinPerm: {},
      sFactorPerm: {},
      sParam: {},
      sFactor: {}, // 因子收益
      sameData:{
        dataValue: [],
        tiem: []
      }   // 换手率分析

    };
  },
  mounted() {
    this.init();
  },
  methods: {
      init () {
        this.data = this.getData;
        this.drawICValue();
        this.drawICDecline();
        this.drawIndustryICValue();
      },
      // 绘制IC值
      drawICValue () {
        const dataLen = this.data.listRealHoldingAdjustDay.length;
        const config = {
          backgroundColor: '#fff',
          color: ['#F15A5A', '#9FCFFF', '#FFD96C'],
          legend: {
            data: [],
            textStyle: {
              color: '#999'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            splitLine: {
              lineStyle: {
                color: '#eee'
              }
            },
            data: []
          },
          yAxis: {
            type: 'value',
            // scale: true,
            splitLine: {
              lineStyle: {
                color: '#eee'
              }
            }
          },
          dataZoom: [
            {
              type: 'slider',
              startValue: 0,
              endValue: dataLen > 10 ? dataLen : 10/* ,
              minValueSpan: dataLen > 10 ? dataLen : 10,
              maxValueSpan: dataLen > 10 ? dataLen : 10, */
            }
          ],
          series: []
        };

        config.xAxis.data = this.data.listRealHoldingAdjustDay;

        config.series.push({
          type: 'bar',
          name: 'IC值',
          data: this.data.listRankIC.map(item => {
            // const value = this.util.number.toFixed(item);
            const value = Number(item).toFixed(4);
            return {
              value,
              itemStyle: {
                color: value >= 0 ? '#F15A5A' : '#9FCFFF',
              },
            };
          }),
        });

        this.$refs.ICValue.render(config);
      },
      // 绘制行业IR值
      drawIndustryICValue () {
        const config = {
          backgroundColor: '#fff',
          color: ['#F15A5A', '#9FCFFF', '#FFD96C'],
          legend: {
            data: [],
            textStyle: {
              color: '#999'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            bottom: 80,
          },
          xAxis: {
            type: 'category',
            splitLine: {
              lineStyle: {
                color: '#eee'
              }
            },
            axisLabel: {
              rotate: 20,
            },
            data: []
          },
          yAxis: {
            type: 'value',
            // scale: true,
            splitLine: {
              lineStyle: {
                color: '#eee'
              }
            }
          },
          series: []
        };

        config.xAxis.data = this.data.listICIRByIndustry.map(item => item.wstrIndustry);

        config.series.push({
          type: 'bar',
          name: '行业IR值',
          data: this.data.listICIRByIndustry.map(item => {
            // const value = this.util.number.toFixed(item.dbValue);
            const value = Number(item.dbValue).toFixed(4);
            return {
              value,
              itemStyle: {
                color: value >= 0 ? '#F15A5A' : '#9FCFFF',
              },
            };
          }),
          animation: false,
        });

        this.$refs.industryICValue.render(config);
      },
      // 绘制IC衰退情况
      drawICDecline () {
        const config = {
          backgroundColor: '#fff',
          color: ['#F15A5A', '#9FCFFF', '#FFD96C'],
          legend: {
            data: [],
            textStyle: {
              color: '#999'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            splitLine: {
              lineStyle: {
                color: '#eee'
              }
            },
            data: []
          },
          yAxis: {
            type: 'value',
            // scale: true,
            splitLine: {
              lineStyle: {
                color: '#eee'
              }
            }
          },
          series: []
        };

        config.xAxis.data = this.data.listICRecession.map(item => item.wstrPeriod);

        config.series.push({
          type: 'bar',
          name: 'IC衰退情况',
          data: this.data.listICRecession.map(item => {
            // const value = this.util.number.toFixed(item.dbValue);
            const value = Number(item.dbValue).toFixed(4);
            return {
              value,
              itemStyle: {
                color: value >= 0 ? '#F15A5A' : '#9FCFFF',
              },
            };
          }),
          animation: false,
        });

        this.$refs.ICDecline.render(config);
      }
  }
};
</script>
<style lang="less" scoped>
.tacticsBox {
  .tactics {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
    height: 42px;
    line-height: 42px;
    background: rgba(240, 242, 245, 1);
    box-shadow: 0px 0px 8px 0px rgba(239, 242, 255, 1);
    text-shadow: 0px 0px 4px rgba(214, 234, 255, 1);
    padding-left: 10px;
  }
  .UlTOP {
    margin: 34px 0px 33px 48px;
    li:first-child {
      height: 110px;
    }
    li {
      color: #666666;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      border-bottom: 1px solid #dddddd;
      height: 32px;
      line-height: 32px;
      h4 {
        color: #666666;
        font-size: 12px;
        font-weight: bold;
      }
      h3 {
        font-size: 35px;
        font-weight: 400;
        line-height: 50px;
      }
    }
    .ulRed {
      color: #ff5454;
    }
    .ulBule {
      color: #1482f1;
    }
  }
  .pgUp {
    color: #f15a5a;
  }
  .pgDn {
    color: #1bb10a;
  }
  .tacticsUl {
    margin: 0 14px;
    li {
      color: #666666;
      display: inline-block;
      width: 20%;
      text-align: center;
      p:nth-child(1) {
        margin: 18px 0;
        font-size: 16px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
      }
    }
  }
  .shadow {
    box-shadow: 0px 0px 4px 0px rgba(214, 234, 255, 1);
  }
}




  .relation-analysis {
    .strategy-performance-left { margin-right: 10px; }
    .strategy-performance-left, .strategy-performance-right {
      flex: 1;
      background-color: #fff;
      padding: 0 16px 10px;
      p {
        display: flex;
        padding: 10px 4px;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        color: #666;
        font-size: 14px;
      }
    }
    .vue-echarts-wrapper {
      display: inline-block;
      vertical-align: top;
      width: 46%;
      margin: 10px !important;
    }
  }
</style>
